import React from 'react';

/**
 * Required field indicator component
 * Shows a red asterisk (*) to indicate a required field
 */
export const RequiredIndicator: React.FC = () => {
    return <span className="text-red-500">*</span>;
};

